import ShipperDetails from "./ShipperDetails";

export default ShipperDetails;
